import { lazy } from 'react';

const HomePage = lazy(() => import('views/HomePage'));
const BlackHolePage = lazy(() => import('views/BlackHolePage'));
const ArticlesListPage = lazy(() => import('views/ArticlesListPage'));
const ArticlePage = lazy(() => import('views/ArticlePage'));

const Routes = [
  {
    path: '/',
    name: 'HOMEPAGE',
    component: HomePage,
    exact: true
  },
  {
    path: '/aktualnosci',
    name: 'ARTICLES-LIST',
    component: ArticlesListPage,
    exact: true
  },
  {
    path: '/aktualnosci/kategoria/:categorySlug',
    name: 'ARTICLES-LIST-CATEGORY',
    component: ArticlesListPage,
    exact: true
  },
  {
    path: '/aktualnosci/:articleSlug',
    name: 'ARTICLE',
    component: ArticlePage,
    exact: true
  },
  {
    path: '/galerie',
    name: 'GALLERIES-LIST',
    component: ArticlesListPage,
    exact: true
  },
  {
    path: '/galerie/:categorySlug',
    name: 'GALLERIES-LIST-CATEGORY',
    component: ArticlesListPage,
    exact: true
  },
  {
    path: '/galeria/:gallerySlug',
    name: 'GALLERY',
    component: ArticlePage,
    exact: true
  },
  {
    path: '/szukaj/:searchSlug',
    name: 'SEARCH',
    component: ArticlesListPage,
    exact: true
  },
  {
    path: '/404',
    name: 'BACK-HOLE-PAGE',
    component: BlackHolePage,
    exact: true
  },
  {
    path: '/:pageSlug',
    name: 'PAGE',
    component: ArticlePage,
    exact: true
  }
];

export default Routes;
